module.exports = __webpack_public_path__ + "img/en-reward1.d423fb7d.jpg";